import axios from "axios";
import { ref } from "vue";

// const BASE_URL = "https://c.h4hi.org/";
// const BASE_URL = "https://back-api.aldoctoriq-academy.com/";
// const BASE_URL = "http://69.62.114.148:5656/";
const BASE_URL = "https://back-api.driq-academy.com/";
// const BASE_URL = "http://localhost:5656/";


function getAuthToken() {
  return localStorage.getItem("userToken") || sessionStorage.getItem("userToken");
}

export const isLoading = ref(false);

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    isLoading.value = true; 
    const userToken = getAuthToken();
    if (userToken) {
      config.headers["Authorization"] = `Bearer ${userToken}`;
    }
    return config;
  },
  (error) => {
    isLoading.value = false; 
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    isLoading.value = false;
    return response;
  },
  (error) => {
    isLoading.value = false;
    return Promise.reject(error);
  }
);

export default api;
